import React from "react";

const tiers = [
  {
    code: "01 · STRATEGY",
    title: "Board and C-level strategy",
    d: "P&L and roadmap ownership, stakeholder and board communication, and the technical arm of bids worth £15m to £20m.",
  },
  {
    code: "02 · DISCOVERY",
    title: "Discovery and research",
    d: "User research, service design, and jobs-to-be-done thinking that find the real problem early. Twenty research sessions ran inside one four-week BBC discovery.",
  },
  {
    code: "03 · SYSTEMS",
    title: "Product and systems thinking",
    d: "Team Topologies, continuous discovery, and architecture that keeps options open: event sourcing, deterministic replay, privacy by design.",
  },
  {
    code: "04 · ARCHITECTURE",
    title: "Enterprise architecture",
    d: "Event-sourced, CQRS platforms and serverless microservices, architected for national institutions: the NHS, the BBC, and UK financial services.",
  },
  {
    code: "05 · SCALE",
    title: "Engineering at scale",
    d: "Consolidated 8 siloed platforms into one national portal connecting every UK gambling operator, handling 300m+ transactions a day. An NHS platform architected for 20 billion transactions a year.",
  },
  {
    code: "06 · FOUNDATIONS",
    title: "Mathematics and data science",
    d: "A first-class degree in mathematics (algebraic geometry, topology, algebraic number theory) underneath the forecasting and machine-learning work: Darts, SARIMAX, XGBoost.",
  },
];

const CapabilitySpectrum = () => (
  <div className="relative">
    {tiers.map((t, i) => (
      <div key={t.code} className="relative flex gap-6 pb-10 last:pb-0 sm:gap-10">
        <div className="relative flex w-5 flex-none flex-col items-center">
          <span
            className="network-node relative z-10 mt-1.5 h-3 w-3 shrink-0 rounded-full bg-accent"
            style={{ animationDelay: `${i * 0.3}s` }}
          />
          {i < tiers.length - 1 && <span className="rail-line mt-1 w-px flex-1" />}
        </div>
        <div className="pb-2">
          <span className="font-mono text-xs font-medium uppercase tracking-[0.18em] text-ink-faint">
            {t.code}
          </span>
          <h3 className="mt-1 text-xl font-bold text-ink sm:text-2xl">{t.title}</h3>
          <p className="mt-2 max-w-xl text-ink-soft">{t.d}</p>
        </div>
      </div>
    ))}
  </div>
);

export default CapabilitySpectrum;
